import { render, staticRenderFns } from "./import.vue?vue&type=template&id=16979d74&scoped=true"
import script from "./import.vue?vue&type=script&lang=js"
export * from "./import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16979d74",
  null
  
)

export default component.exports